// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scrollable-container[data-v-1f903287]{position:relative;width:100%;height:100%;overflow-y:auto;display:flex;justify-content:center;align-items:flex-start}.canvas-svg[data-v-1f903287]{display:block;background:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
